// extracted by css-extract-rspack-plugin
export default {"loadingState":"loadingState-V1CyjL"};